import { ArticleBuilder } from '@wix/answers-api';
import { AppEventType } from './index';
import { noop } from '@wix/answers-lib';
export var randomTicketLinkedEvent = function () {
    var someArticle = ArticleBuilder.generateRandomList(1)[0];
    var source = 'search';
    var order = 4;
    var searchTerm = 'bob';
    return {
        type: AppEventType.ARTICLE_LINKED_TO_TICKET,
        data: {
            article: someArticle,
            meta: {
                searchTerm: searchTerm,
                order: order,
                source: source,
                attachMethod: 'immediate',
                expanded: false
            }
        }
    };
};
export var createEngagementLoggerTestkit = function () { return ({
    ticketList: noop,
    views: noop,
    ticketPage: noop,
    bulkActions: noop,
    ticketItem: noop,
}); };
//# sourceMappingURL=test-utils.js.map